import React from 'react'

import { Collapse } from 'antd'

import type { LntCollapseProps } from './types'

export const LntCollapse: React.FC<LntCollapseProps> = props => {
  const { children, ...restProps } = props

  return <Collapse { ...restProps }>{ children }</Collapse>
}
